import {
    CHANGE_LANGUAGE,
    SET_ENVS
} from '../actions/types';

const INIT_STATE_APP = {
    lang: ''

};

export default function(state = INIT_STATE_APP, action) {
    switch (action.type) {
        case CHANGE_LANGUAGE:
            return {
                ...state,
                lang: action.payload
            }
        case SET_ENVS: {
            return {
                ...state,
                environments: action.environments
            }
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js